import _ from "lodash";
import store from "CommonState/store";
import {
  Component,
} from "react";
import {
  Button, Alert, Modal,
} from "react-bootstrap";
import {
  Spinner,
} from "CommonComponents/bricks";
import {
  SVAExport,
} from "Apis/antrag-api";
import {
  DetailEditor,
} from "CommonComponents/detail-view";
import {
  formatKonto,
} from "Apis/massnahme-api";

@store("k_geldgeber")
export default class AntragExportierenPopup extends Component {
  constructor() {
    super();
    this.state = { edits: {} };
  }

  getAbrObjekte() {
    const { antrag } = this.props;
    const abrobjekte = [];
    _.map(antrag.massnahmen, m => {
      _.map(m.massnahmefinanz, mf => {
        const key = formatKonto({ kostenstelle: mf.mfi_kostenstelle, budgetkonto: mf.mfi_budgetkonto });
        if (abrobjekte.indexOf(key) < 0) {
          abrobjekte.push(key);
        }
      });
    });

    return abrobjekte;
  }

  render() {
    const { onClose, onCancel, k_geldgeber } = this.props;
    const { errorMessage, done, inflight } = this.state;

    // Abrechnungsobjekte sammeln

    const mySchema = {
      table: [
        {
          field: "geldgeber",
          type: "select",
          hideLabel: true,
          choices: _.map(k_geldgeber, x => ({ value: x.gg_id, label: x.gg_bez })),
          selector: list => id => _.get(_.find(list, hi => hi.gg_id === id), "gg_bez"),
        },
      ],
    };

    return (

      <Modal show onHide={onCancel}>
        <Modal.Header>
          <h2>Export nach SVA</h2>
        </Modal.Header>
        <Modal.Body>
          {!done && <p>Bitte geben Sie vor dem Export den Geldgeber an:</p>}
          <table width='100%'>
            <tbody>
              {!done && _.map(this.getAbrObjekte(), abr => <tr key={abr}>
                <td width='40%'><b>Abrechungsobjekt {abr}:</b></td>
                <td width='60%' style={{ paddingTop: "15px" }}><DetailEditor
                  editable
                  leftCol={1}
                  rightCol={11}
                  defaultEditable
                  action='Speichern'
                  schema={mySchema}
                  entity={(this.state.edits || {})[abr] || {}}
                  onChange={change => this.onChange(abr, change)}
                /></td></tr>)}
            </tbody>
          </table>
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
          {inflight && <span><h4>Daten werden an SVA übertragen ...</h4><Spinner /></span>}
          {done && <h4>Der Antrag wurde erfolgreich übertragen.</h4>}
        </Modal.Body>
        <Modal.Footer>
          {!errorMessage && !inflight && !done && [<Button key='first' variant='primary' disabled={this.anyEmpty()} onClick={this.export}>Exportieren</Button>,
                                                   <Button key='second' variant='outline-primary' onClick={onCancel}>Abbrechen</Button>]
          }
          {!errorMessage && done && <Button variant='primary' onClick={onClose}>Ok</Button>}
          {errorMessage && <Button variant='primary' onClick={onCancel}>Ok</Button>}
        </Modal.Footer>
      </Modal>

    );
  }

  anyEmpty = () => {
    // Prüfen, ob noch Angaben fehlen
    return _.find(this.getAbrObjekte(), x => !this.state.edits[x] || !this.state.edits[x].geldgeber);
  };

  onChange = (abrobjekt, change) => {
    const { edits } = this.state;

    if (!edits[abrobjekt]) {
      edits[abrobjekt] = {};
    }

    _.assign(edits[abrobjekt], change);
    this.setState({ edits });
  };

  export = async() => {
    const { antrag, k_geldgeber } = this.props;
    try {
      this.setState({ inflight: true, done: false });

      // Geldgeber aufbereiten
      const gg = {};
      _.map(this.getAbrObjekte(), abr => {
        gg[abr] = (_.find(k_geldgeber, g => this.state.edits[abr].geldgeber == g.gg_id) || {}).gg_nr;
      });

      await SVAExport(antrag.a_id, gg);
      this.setState({ inflight: false, done: true });
    } catch(err) {
      this.setState({
        inflight: false,
        errorMessage:
          "Export nach SVA:" + (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
      return false;
    }
  };
}
